/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import http from "utilities/http";
import { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import SlideImage from "components/shop/detail/slide-image";
import DetailInfo from "components/shop/detail/product-info";
import RelateProduct from "components/shop/detail/relate-product";
import { IMG_URL, API_IMG } from "utilities/constants";
import { isArray, isEmpty, clone } from "lodash";
import Bread from "components/shop/breadCrumbListSku";
import Link from 'next/link';
import Comment from "components/shop/product/comment";
import { getCookie } from "../../../framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_SHOP } from "../../../framework/store/constants";
import dayjs from "dayjs";
import SliderDouble from "components/cong-dong/chi-tiet/slide-doubleShow";
import { toast } from "react-toastify";
import { replaceAll, formatSku } from 'utilities/helper';
import { useCart } from "framework/store";
import { upperCaseFirst } from 'utilities/helper';
import Head from "next/head";
import { getUrlName } from 'utilities/helper';
import StarList from "components/shop/review/starList";
import { ProductSchema } from "../../../schemas/ProductSchema";

export default function ShopDetail({
    productDetail,
    productId,
    sku,
    imagesProduct,
    reviewsSSR,
    qaSSR,
    breadCrumbSSR
}) {
    const pcOnly = useRef(null);
    const spOnly = useRef(null);

    //Lưu sản phẩm đã xem 
    const saveRecent = async () => {
        const res = await http(`/rest/V1/recent/mine/${formatSku(sku)}`, {}, { method: 'POST', token: 'Bearer ' + getCookie(TOKEN_SHOP) });
    };

    useEffect(() => {
        if (isEmpty(getCookie(TOKEN_SHOP))) return;
        saveRecent();
    }, []);
    const vendorId = productDetail?.custom_attributes?.vendor_id || null;

    const [stateStore, actions] = useCart();
    const vendorList = stateStore.vendorList;
    // const vendor = vendorList.find(x => x.id == vendorId) || {};

    const [vendor, setVendor] = useState({});
    const fetchVendor = async () => {
        const res = await http(`/rest/V1/vendor/${vendorId}`, {}, {});
        res.id = vendorId;
        setVendor(res);
    };
    useEffect(() => {
        fetchVendor();
    }, []);

    const [spDaXem, setSpDaXem] = useState([]);

    const fetchSanPhamDaXem = async () => {
        const spThuongDuocMuaCungParams = { size: 24 };
        const res = await http(`/rest/V1/recent/mine`, spThuongDuocMuaCungParams, { token: 'Bearer ' + getCookie(TOKEN_SHOP) });
        setSpDaXem(res?.items || []);
    };
    const loginUser = async () => {
        const res = await http(`user`, {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) });
        setState({
            user: res
        });
    };

    useEffect(() => {
        if (isEmpty(getCookie(TOKEN_SHOP))) return;
        fetchSanPhamDaXem();
        loginUser();
    }, []);
    //modal detail
    const [state, _setState] = useState({
        modal: false,
        rateProducts: null,
        modalComplete: false,
        modalCompleteContent: false,
        question: false,
        buy: false,
        logined: isEmpty(getCookie(TOKEN_CONGDONG)) ? false : true,
        qAG: qaSSR,
        qAContent: "",
        qAName: stateStore.profileCommunity?.display_name || '',
        user: {}
    });
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };

    let completeContent = [
        {
            "header": "Gửi đánh giá thành công",
            "content": "Đánh giá của bạn đã được gửi thành công. Chúng tôi sẽ phản hồi sớm nhất đến bạn!"
        }, {
            "header": "Gửi câu hỏi thành công",
            "content": "Nhà cung cấp sẽ phản hồi sớm nhất đến bạn"
        }
    ];
    //modal
    let rateProduct = {
        "image": "/images/img-sale03.png"
    };
    const genProductChoose = (() => {
        return (
            <Modal show={state.buy} onHide={() => setState({ buy: false })} role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Chọn sản phẩm</h5>
                </Modal.Header>
                <Modal.Body className="modal-question-creat">
                    <h3 className="font-weight-medium mb-3">Câu hỏi của bạn</h3>
                    <textarea className="form-control textarea-question"
                        placeholder="Sản phẩm của Shop có ship đến nơi không? Chi phí lắp đặt như thế nào?" />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="col-sm-6" onClick={() => setState({ buy: false })}>
                        Gửi câu hỏi
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    });
    const onQA = async () => {
        if (state.qAContent.length >= 1) {
            setState({
                question: false,
                modalComplete: true,
                modalCompleteContent: completeContent[1]
            });
            const res = await http('/rest/default/V1/maxbo-productqa/question', {}, {
                body: {
                    question: {
                        product_id: productId,
                        vendor_id: vendorId,
                        name: state.qAName || "Khách hàng",
                        content: state.qAContent
                    }
                },
                method: 'POST',
            }, 'v1');
            if (res?.question_id) {
                setState({
                    modal: false,
                    modalComplete: true,
                    modalCompleteContent: completeContent[1],
                    qAContent: "",
                });
                fetchListQA();
            }
        }
    };
    const fetchListQA = async () => {
        const prams = {
            filters: [[{
                field: 'product_id',
                value: productId,
                condition_type: 'eq'
            },], [],]
        };
        const res = await http(`/rest/default/V1/maxbo-productqa/getList`,
            prams,
            { token: 'default' },
            "v1");
        if (res?.items.length) {
            setState({ qAG: res });
        }
    };
    useEffect(() => {
        fetchListQA();
    }, []);
    useEffect(() => {
        setState({ qAName: stateStore.profileCommunity?.display_name });
    }, [stateStore.profileCommunity]);
    const genQuestion = () => {
        return (
            <Modal show={state.question} onHide={() => setState({ question: false })} className="modal-question-create"
                role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Tạo câu hỏi</h5>
                </Modal.Header>
                <Modal.Body>
                    {isEmpty(getCookie(TOKEN_SHOP)) &&
                        <>
                            <h3 className="font-weight-medium mb-1">Tên của bạn</h3>
                            <input className="form-control textarea-question mb-3" type="text"
                                value={state.qAName}
                                onChange={e => { setState({ qAName: e.currentTarget?.value }); }}
                                placeholder="Nhập tên của bạn"
                            />
                        </>
                    }
                    <h3 className="font-weight-medium mb-1" style={{ paddingTop: "0px" }}>Câu hỏi của bạn</h3>
                    <textarea className="form-control textarea-question" style={{ paddingTop: "10px" }}
                        value={state.qAContent}
                        onChange={e => { setState({ qAContent: upperCaseFirst(e.currentTarget?.value) }); }}
                        placeholder="Sản phẩm của Shop có ship đến nơi không? Chi phí lắp đặt như thế nào?" />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="col-sm-6" onClick={onQA} disabled={state.qAContent?.length > 0 ? false : true}>
                        Gửi câu hỏi
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
    const genModalComplete = (() => {
        return (
            <Modal show={state.modalComplete} onHide={() => setState({ modalComplete: false })}
                className="modal--confirm">
                <Modal.Header closeButton>
                    <Modal.Title>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="confirm-icon mb-3 text-center"><Image width={24} height={24}
                        src="/images/icon-radio-tick.svg" align=""
                        alt="" /></div>
                    <h3 className="confirm-title">{state.modalCompleteContent?.header}</h3>
                    <p className="texxt-center">{state.modalCompleteContent?.content}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="col-sm-12" onClick={() => setState({ modalComplete: false })}>
                        Đã hiểu
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    })();

    const genModalContent = function (productDetail) {
        const [star, setStar] = useState(5);
        const onClickFunc = (num) => { setStar(num); };
        const [photos, setPhotos] = useState("");
        const [preview, setPreview] = useState("");
        const [displayPreview, setDisplayPreView] = useState([]);
        const addMoreImage = (event) => {
            if (event.target.files && event.target.files[0]) {
                const file = event.target.files[0];
                setPhotos(file);
            }
        };
        useEffect(() => {
            if (photos) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                };
                reader.readAsDataURL(photos);
            } else {
                setPreview(null);
            }
        }, [photos]);
        useEffect(() => {
            if (preview) {
                const displayPreviewG = [...displayPreview];
                displayPreviewG.push(preview);
                setDisplayPreView(displayPreviewG);
            }
        }, [preview]);
        const [comment, setComment] = useState('');
        const [name, setName] = useState('');
        //push api
        const [postId, setPostId] = useState(productDetail?.id);
        const bodyComment = () => {
            const bodyComment = {
                review: {
                    title: "test title",
                    nickname: state?.user?.display_name || "Khách hàng",
                    detail: comment,
                    entity_id: 1,
                    entity_pk_value: postId,
                    review_status: 2,
                    review_entity: "product",
                    ratings: [{
                        rating_id: 1,
                        value: star,
                        rating_name: "Quality",
                        percent: star * 20
                    }],
                    images: (() => {
                        if (displayPreview?.length > 0) {
                            return (displayPreview.map(x => {
                                return ({
                                    type: "jpg",
                                    name: "handsome",
                                    base64_encoded_data: x.slice(22)
                                });
                            }));
                        } else {
                            return ({
                                type: "jpg",
                                name: "handsome",
                                base64_encoded_data: ""
                            });
                        }
                    })()
                }
            };
            return bodyComment;
        };
        const onComment = async () => {
            setValidateLength(comment?.length >= 1 ? false : true);
            if (isEmpty(getCookie(TOKEN_SHOP))) {
                if (comment?.length >= 1) {
                    const res = await http('/rest/V1/guest/reviews', {}, {
                        body: bodyComment(),
                        method: 'POST',
                    }, 'v1');
                    if (res?.id) {
                        setState({
                            modal: false,
                            modalComplete: true,
                            modalCompleteContent: completeContent[0],
                        });
                        fetchData();
                        setComment('');
                        setName("");
                        setDisplayPreView([]);
                    }
                }
            } else {
                if (comment?.length >= 1) {
                    const res = await http(`/rest/V1/mine/reviews`, {}, {
                        method: 'POST',
                        body: bodyComment(),
                        token: "Bearer " + getCookie(TOKEN_SHOP)
                    });
                    if (res?.id) {
                        setState({
                            modal: false,
                            modalComplete: true,
                            modalCompleteContent: completeContent[0],
                        });
                        fetchData();
                        setComment('');
                        setName("");
                        setDisplayPreView([]);
                    }
                }
            }
        };
        const [validateLength, setValidateLength] = useState(false);
        let imgUrl = "";
        if (productDetail.custom_attributes) {
            const atributeImgUrl = productDetail.custom_attributes.image;
            const atributeThumbnail = productDetail.custom_attributes.thumbnail;

            imgUrl = IMG_URL + (atributeImgUrl || atributeThumbnail);
        }

        if (productDetail.thumbnail_url) {
            imgUrl = productDetail.thumbnail_url;
        }
        if (productDetail.image) {
            imgUrl = productDetail.image;
        }
        if (imgUrl.includes('/undefined')) {
            imgUrl = IMG_URL + productDetail.media_gallery_entries[0]?.file;
        };
        return (
            <Modal show={state.modal} onHide={() => setState({ modal: false })} className="sku-modal-danh-gia">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Tạo đánh giá nhanh
                        {/* <div className="poin_items">+8.000
                            điểm uy tín
                        </div> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-quick-review">
                        <div className="product-review">
                            <div className="thumb">
                                <Image width={40} height={40} src={imgUrl} align="" alt="" />
                            </div>
                            <div className="product-name">{productDetail?.name}</div>
                        </div>
                        <h3 className="font-weight-medium mb-3">Mức độ hài lòng với sản phẩm</h3>
                        <StarList number={star} size={26} onClickFunc={onClickFunc} />
                        <h3 className="font-weight-medium mb-2">Thêm ảnh sản phẩm thực tế</h3>
                        <p className="guide-upload-thumb">Vui lòng tải lên chính xác ảnh liên quan đến sản phẩm
                            Những bức ảnh không liên quan sẽ bị xóa và bạn cũng sẽ không nhận được điểm uy tín.
                        </p>
                        <ul className="formUpload-thumb mb-4" key={2}>
                            {
                                displayPreview?.map((x, i) => {
                                    return (
                                        <li key={i} className={"wrap-next-image"}>
                                            <Image layout={"fill"} src={x} align="" alt="" />
                                        </li>
                                    );
                                })
                            }

                            <li>
                                <label className="custom-control custom-file">
                                    <span className="btn">
                                        <input className="custom-file-input" type="file" name="myImage" onChange={addMoreImage} />
                                        <Image layout={"fill"} src="/images/btn-upload-thumb.svg" alt="" />
                                    </span>
                                </label>
                            </li>
                        </ul>
                        {/* { isEmpty(getCookie(TOKEN_SHOP))
                            ?(<>
                                <div className="d-flex flex-wrap justify-content-between">
                                    <h3 className="font-weight-medium mb-3">Tên của bạn</h3>
                                    { validateName ?  <span className="text-guide-cmt" style={{fontWeight : "bold"}}>Tên của bạn là bắt buộc</span> : "" }
                                </div>
                                <textarea className="textarea-cmt" style={{minHeight : "10px"}} maxLength="50" value={name} onChange={e => { setName(e.currentTarget?.value); }} placeholder="Hãy nhập tên của bạn">
                                </textarea>
                            </>)
                            : <></>
                        } */}
                        <div className="d-flex flex-wrap justify-content-between">
                            <h3 className="font-weight-medium mb-3">Đánh giá của bạn</h3>
                            {/* { validateLength ?  <span className="text-guide-cmt" style={{fontWeight : "bold"}}>Tối thiểu 20 từ</span> : "" } */}

                        </div>
                        <textarea className="textarea-cmt" value={comment} onChange={e => setComment(upperCaseFirst(e.currentTarget?.value))} placeholder="Hãy nhập nội dung đánh giá...">
                        </textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="col-sm-6" disabled={comment?.length > 0 ? false : true} onClick={() => { onComment(); }} >
                        Đăng
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
    const genRating = (w, h, rate) => {
        return [1, 2, 3, 4, 5].map(item => {
            return (<li key={item} style={{ display: "flex" }}>
                <Image width={w} height={h} className="svg" src={item <= (rate || 0) ? "/images/icon-star.svg" : "/images/icon-star-gray.svg"} alt="" /></li>);
        });
    };

    //--------------------------------Thông số kỹ thuật--------------------------------
    const detailInfo = productDetail.extension_attributes?.detail_information || [];
    const ThongSoKyThuat = <div id="product-parameter" className="anchor-link">
        <div className="groupCategory-title">
            <h2 className="groupCategory-tlt">Thông số kỹ thuật</h2>
        </div>
        <table className="table-parameter">
            <tbody>
                {
                    detailInfo.map((info, index) =>
                        <tr key={index}>
                            <th>{info.label}</th>
                            <td>{info.value}</td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    </div>;

    //--------------------------------Mô tả sản phầm--------------------------------
    const dieuKienThuGon = (productDetail?.custom_attributes?.description && productDetail?.custom_attributes?.description.length > 200)
        || (productDetail?.custom_attributes?.meta_description && productDetail?.custom_attributes?.meta_description.length > 200);
    const [seeMore, setSeeMore] = useState(dieuKienThuGon ? false : true);
    const createMarkup = () => {
        let des = productDetail?.custom_attributes?.description || productDetail?.custom_attributes?.meta_description;

        if (!des) return;
        des = replaceAll(des, '{{media url=&quot;', `${API_IMG}media/`);
        des = replaceAll(des, '&quot;}}', '');
        des = replaceAll(des, 'href', 'hrefx');
        return { __html: des };
        // return parse(des);
    };
    const MoTaSanPham = <div id="product-describe" className="anchor-link" style={!dieuKienThuGon ? { paddingBottom: 0 } : {}}>
        <div className="groupCategory-title">
            <h2 className="groupCategory-tlt">Mô tả sản phẩm</h2>
        </div>
        {/* <div className="text-center mb-3 wrap-next-image">
            <img src={IMG_URL + (productDetail?.media_gallery_entries)[0]?.file} align="" alt="" />
        </div> */}
        {/* <p className="text-center mb-4">{productDetail?.custom_attributes?.meta_title}</p> */}
        {(productDetail?.custom_attributes?.description || productDetail?.custom_attributes?.meta_description) && <div className={"descript-block " + (seeMore ? "no-hidden" : "hiden")}>
            <div className="text product-description"
                style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={createMarkup()}
            >
            </div>
            {
                !seeMore && <button className="btn btn--blue btn-readmore" onClick={() => setSeeMore(!seeMore)}>Xem chi tiết
                    <img src="/images/icon-arrow-down.svg" align="" alt="" className="ml-1" />
                </button>
            }
            {
                dieuKienThuGon && seeMore && <button className="btn btn--blue btn-readmore btn-thugon" onClick={() => setSeeMore(!seeMore)}>Thu gọn</button>
            }
        </div>}
    </div>;

    ////--------------------------------Đánh giá từ người dùng //--------------------------------
    // const [review , setReview] = useState(reviewInit);
    const [CountViewRating, setCountViewSetting] = useState(0);
    const [reviewG, SetReviewG] = useState(reviewsSSR || []);
    const [list, setList] = useState([]);
    const [overViewRatting, setOverViewRating] = useState(0);
    const [commentMode, setCommentMode] = useState('pho-bien');
    const [sortInit, setSortInit] = useState(true);
    const [reviewDisplay, setReviewDisplay] = useState([]);

    const fetchData = async () => {
        const response = await http(`/rest/V1/products/${sku}/reviews`);
        if (response.message) return;
        SetReviewG(response || []);
        setReviewDisplay(response);
        setCountViewSetting(response.length);
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        setCountViewSetting(reviewG?.length);
        setList(() => {
            const res = [0, 0, 0, 0, 0];
            reviewG.map(a => {
                a?.ratings[0]?.value ? res[a?.ratings[0]?.value - 1]++ : "";
            });
            return res.reverse();
        });
        setCountViewSetting(() => {
            let res = 0;
            reviewG.map(a => {
                a?.ratings[0]?.value ? res++ : "";
            });
            setOverViewRating(() => {
                const rate = reviewG.reduce((x, a) => x + (a?.ratings[0]?.value || 0), 0) / res || 0;
                return Number.isInteger(rate) ? rate : rate.toFixed(1);
            });
            return res;
        });
        setSortInit(true);
    }, [reviewG]);
    useEffect(() => {
        sortInit ? setSortInit(false) : "";
        !sortInit ? setReviewDisplay(clone(reviewDisplay).reverse()) : "";
    }, [commentMode]);
    const DanhGiaTuNguoiDung = <div id="product-comment" className="anchor-link">
        <div className="title-main">
            <div className="title-main-left">
                <h2 className="tlt">Đánh giá sản phẩm</h2>
                <div className="evaluate">
                    <StarList number={overViewRatting} />
                    <span
                        className="evaluate-number">{overViewRatting || 0}/5</span>
                    <span
                        className="evaluate-number-fl">({CountViewRating || 0} đánh giá)</span>
                </div>
            </div>
            <div className="btn-review">
                <div className="pb-2">
                    <button className="btn btn--blueWhite"
                        onClick={() => {
                            if (isEmpty(getCookie(TOKEN_SHOP))) {
                                toast.info('Bạn cần đăng nhập để thao tác.');
                                return;
                            }
                            setState({
                                modal: true,
                                rateProducts: rateProduct
                            });
                        }}>Đánh giá nhanh
                    </button>
                </div>
                {/* <div>
                    <div className="poin_items">+8.000 điểm uy tín</div>
                </div> */}
            </div>
        </div>
        <div className="boxEvaluate">
            <div className="evaluate-fl">
                <div className="evaluate-star">
                    <span>{overViewRatting || 0}</span>
                    <StarList number={overViewRatting} />
                </div>
                <div className="evaluate-content">
                    <ul>
                        {list?.map((x, i) => {
                            return (
                                <li key={i}>
                                    <div className="evaluate-number">{list.length - i}
                                        <span><Image width={14} height={14} src="/images/icon-star.svg" alt="" /></span>
                                    </div>
                                    <div className="evaluate-side">
                                        <span style={{ width: `${x / CountViewRating * 100}%` }}></span>
                                    </div>
                                    <div className="evaluate-percent">{x}</div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
        {!isEmpty(reviewDisplay) && <div className="evaluate-cmt" style={{ borderBottom: 'none' }}>
            <div className="evaluate-nav">
                <ul>
                    <li onClick={() => setCommentMode('pho-bien')} style={{ cursor: 'pointer' }}><a className={commentMode === 'pho-bien' ? "active" : ""}>Phổ biến</a></li>
                    <li onClick={() => setCommentMode('moi-nhat')} style={{ cursor: 'pointer' }}><a className={commentMode === 'moi-nhat' ? "active" : ""}>Mới nhất</a></li>
                </ul>
            </div>
            <div className="evaluate-select">
            </div>
        </div>}
        <Comment review={reviewDisplay} />
    </div>;

    const [tagImages, setTagImages] = useState([]);
    const [stickyMenu, setStickyMenu] = useState('product-user-thumb');

    useEffect(() => {
        const fetch = async () => {
            const res = await http(`community/photo/product-images/?sku=${`${sku}`}`, {}, { token: 'Bearer 11|UGW93Do0X1bll4oRKCK8UD9ZA75TjEocpPGgqFIb' }, 'v2');
            setTagImages(res?.data || []);
            setStickyMenu(!isEmpty(res?.data) ? 'product-user-thumb' : 'product-parameter');
        };
        fetch();
    }, []);


    const sticketMenuList = [{
        id: 'product-user-thumb',
        title: 'Ảnh từ người dùng',
    }, {
        id: 'product-parameter',
        title: 'Thông số',
    }, {
        id: 'product-describe',
        title: 'Mô tả',
    }, {
        id: 'product-comment',
        title: 'Đánh giá',
    }, {
        id: 'product-QA',
        title: 'Hỏi đáp',
    }];

    const stickyRender = sticketMenuList.map((item, index) => {
        if (item.id == 'product-user-thumb' && isEmpty(tagImages)) return <></>;
        if (item.id == 'product-describe' && !(productDetail?.custom_attributes?.description || productDetail?.custom_attributes?.meta_description)) return <></>;

        return <li key={index} className="nav-item" onClick={() => setStickyMenu(item.id)}>
            <a className={stickyMenu === item.id ? "nav-link active" : "nav-link"} href={'#' + item.id} role="tab">{item.title}</a>
        </li>;
    });

    const [sideBanner, setSideBanner] = useState({});
    useEffect(() => {
        const fetchBanner = async () => {
            const res1 = await http(`banner/serve?position=4&page=57`, {}, {}, 'v2');
            setSideBanner(res1.data);
        };
        fetchBanner();
    }, []);
    const link = `https://happynest.vn/shop/${formatSku(productDetail.sku)}/${getUrlName(productDetail.name)}.html`;
    const schema = new ProductSchema(productDetail, imagesProduct, breadCrumbSSR, reviewsSSR);
    const renderSchema = schema.init();

    return (
        <>
            <Head>
                <title>{productDetail.name}</title>
                <meta property="og:title" content={productDetail.name} key="title" />
                <meta property="description" content={productDetail.custom_attributes?.meta_description || productDetail.name} key="description" />
                <meta property="og:description" content={productDetail.custom_attributes?.meta_description || productDetail.name} key="og:description" />
                <meta property="og:keywords" content={productDetail.custom_attributes?.meta_keyword || productDetail.name} key="keywords" />
                <meta property="og:image" content={(!isEmpty(imagesProduct) && imagesProduct[0].full) ? imagesProduct[0].full : 'https://happynest.vn/v2019/img/logo-seo-happynest.png'}></meta>
                <link rel="canonical" href={link} />
                <meta property="og:url" content={link} />
                {
                    renderSchema.map((item, index) => {
                        return <script type="application/ld+json" key={index} dangerouslySetInnerHTML={{
                            __html: JSON.stringify(item)
                        }}></script>;
                    })
                }
            </Head>
            <section className="main main--shop _shopDetail">
                <div className="breadcrumb-head pc-only" ref={pcOnly}>
                    <div className="wrap">
                        {pcOnly.current?.getBoundingClientRect()?.width > 0 && <Bread product={productDetail} />}
                    </div>
                </div>


                <div className="detail_product-head">
                    <div className="wrap">
                        {/* <SlideImage imageList={productDetail?.media_gallery_entries} item={productDetail}></SlideImage> */}
                        <SlideImage imageList={imagesProduct} item={productDetail}></SlideImage>
                        {/* <Bread item={breadCrumb} type="line"></Bread> */}
                        <div ref={spOnly} className="sp-only" style={{ width: '100%' }}>
                            {spOnly.current?.getBoundingClientRect()?.width > 0 && <Bread product={productDetail} />}
                        </div>
                        <DetailInfo productDetail={productDetail} vendor={vendor}></DetailInfo>
                    </div>
                </div>

                <RelateProduct listName="Sản phẩm tương tự" url={`/rest/V1/vendors/products/${`${sku}`}/links/related`} />

                <div className="product-shop">
                    <div className="wrap">
                        <div className="groupCategory-title mb-0">
                            <Link href={`/shop/profile/${vendorId}/${getUrlName(vendor.company || vendor.shop_name || vendor.name)}`} passHref={true}>
                                <div className="user__shop-info" style={{ cursor: 'pointer' }}>
                                    <div className="shop-thumb wrap-next-image"><Image width={40} height={40}
                                        src={vendor.logo || "/images/icon-app.svg"}
                                        alt="" /></div>
                                    <div className="shop-detail">
                                        <div className="info-head">
                                            <span className="shop-name">{vendor.company || vendor.name}</span>
                                            {/* •<span className="btn-flow">Theo dõi</span> */}
                                        </div>
                                        <div className="rate-star">
                                            <StarList number={(Math.round(vendor.rating_summary / 2) / 10)} />
                                            <span className="number">({vendor.review_count || 0})</span>
                                        </div>

                                    </div>
                                </div>
                            </Link>
                            <Link href={`/shop/profile/${vendorId}/${getUrlName(vendor.company || vendor.shop_name || vendor.name)}`}><a className="btn btn--blue pc-only">Xem Shop</a></Link>
                        </div>
                        <RelateProduct url={`/rest/V1/vendors/featuredProduct/${vendorId}`} />
                    </div>
                </div>
                <div className="product_detail-wrap">
                    <div className="product_detail-tabs product_detail-sticky" style={{
                        position: 'sticky',
                        zIndex: 100,
                    }}>
                        <div className="wrap">
                            <ul className="nav nav-pills">
                                {stickyRender}
                            </ul>
                        </div>
                    </div>
                    <div className="product-block product_detail-content">
                        <div className="wrap">
                            <div className="wrap_banner">
                                <div className="wrap_content">
                                    {/* Ảnh từ người dùng */}
                                    {!isEmpty(tagImages) &&
                                        < div id="product-user-thumb" className="anchor-link">
                                            <div className="groupCategory-title">
                                                <h2 className="groupCategory-tlt">Ảnh từ người dùng <span
                                                    className="c-blue pl-2 number"></span></h2>
                                            </div>
                                            <SliderDouble images={tagImages} mainSku={sku} />
                                        </div>
                                    }


                                    {/* Thông số kỹ thuật */}
                                    {ThongSoKyThuat}

                                    {/* Mô tả sản phẩm */}
                                    {(productDetail?.custom_attributes?.description || productDetail?.custom_attributes?.meta_description) && MoTaSanPham}

                                    {/* Đánh giá từ người dùng */}
                                    {DanhGiaTuNguoiDung}

                                    {/* Hỏi đáp */}
                                    <div id="product-QA" className="anchor-link">
                                        <div className="groupCategory-title">
                                            <h2 className="groupCategory-tlt">Hỏi đáp<span
                                                className="c-blue pl-2 number"></span></h2>
                                            <p onClick={() => { setState({ question: true }); }} className="btn btn--blueWhite">Tạo câu hỏi
                                            </p>
                                        </div>
                                        <ul className="list-question">
                                            {state.qAG?.items?.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <div className="question_wrap">
                                                            <div className="info-head">
                                                                <div className="info-left">
                                                                    <span className="c-blue">Q </span>
                                                                    <span className="question-name">{item?.name}</span>
                                                                </div>
                                                                <span className="question-time">
                                                                    {item?.created_at ? (dayjs(item.created_at).format("DD") + " thg " + dayjs(item.created_at).format("MM, YYYY")) : "no date"}
                                                                </span>
                                                            </div>
                                                            <p className="question-text">{item?.content}</p>
                                                        </div>
                                                        {!isEmpty(item?.answer) &&
                                                            (
                                                                <div className="answer_wrap">
                                                                    <div className="info-head">
                                                                        <div className="info-left c-red">
                                                                            <span>A </span>
                                                                            <span> {vendor.company || vendor.shop_name || vendor.name || vendor.vendor_id}</span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="answer-text">{item?.answer}</p>
                                                                </div>
                                                            )
                                                        }
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                        {/*<div className="viewAll mb-3">*/}
                                        {/*    <button className="btn-viewAll">Xem tất cả <span*/}
                                        {/*        className="number">(56)</span>*/}
                                        {/*    <Image width={14} height={20} src="/images/icon-arrow-listNav.svg"*/}
                                        {/*        alt=""/></button>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                                {sideBanner?.file && <div className="wrap_bnr">
                                    <a className="hover" href={sideBanner?.external_link}>
                                        <Image width={335} height={669} layout="responsive" src={sideBanner?.file} alt="" />
                                    </a>
                                    {/* <div className="foot-group">
                                        <a className="save-bookmark" href="#">
                                            <span className="icon"><Image width={14} height={14}
                                                src="/images/icon-bookmark01.svg"
                                                alt=""/></span>
                                            <span className="number">15</span>
                                        </a>
                                        <button className="btn btn--blueWhite" onClick={() => addProductToCart()}>Thêm
                                            vào giỏ
                                        </button>
                                        <button className="btn btn--blue">Mua ngay</button>
                                    </div> */}
                                </div>}
                            </div>

                        </div>
                    </div>
                </div>

                <RelateProduct listName="Thường được mua cùng" url={`/rest/V1/vendors/products/${`${sku}`}/links/crosssell`} />
                <RelateProduct listName="Sản phẩm đã xem" productList={spDaXem} />
                <RelateProduct listName="Gợi ý cho bạn" url={`/rest/V1/vendors/products/${`${sku}`}/links/upsell`} />

            </section>
            {genModalContent(productDetail)}
            {genModalComplete}
            {genQuestion()}
            {genProductChoose}
        </>
    );
};

export const getServerSideProps = async (context) => {
    const { params } = context;
    const sku = params.sku[0];
    const res = await Promise.all([
        http(`/rest/V1/vne/products/${`${formatSku(sku)}`}`, {}, { token: 'default' }),
        http(`/rest/V1/products/${`${formatSku(sku)}`}/images`, {}),
    ]);

    if (!res[0]?.id) {
        return {
            notFound: true,
        };
    }

    const productDetail = res[0];
    const productId = productDetail.id;
    if (!isEmpty(productDetail.custom_attributes) && isArray(productDetail.custom_attributes)) {
        productDetail.custom_attributes = Object.assign({}, ...productDetail.custom_attributes.map(item => ({ [item.attribute_code]: item?.value })));
    }

    let reviews = [];
    let qaList = [];
    let breadCrumb = [];
    const isGooglebot = /Googlebot/.test(context.req.headers['user-agent']);
    // Nếu đây là Googlebot, sử dụng SSR để tạo ra dữ liệu trang
    if (isGooglebot) {
        reviews = await http(`/rest/V1/products/${sku}/reviews`, {});
        qaList = await http(`/rest/default/V1/maxbo-productqa/getList`,
            {
                filters: [[{
                    field: 'product_id',
                    value: productId,
                    condition_type: 'eq'
                }]]
            }, { token: 'default' }, "v1");

        const categoriesParams = {
            filters: [[{
                field: 'level',
                value: '0',
                condition_type: 'gt'
            }]],
            size: 0,
        };
        const resCategories = await http('/rest/V1/categories/list', categoriesParams, { token: 'default' });
        let shopUrl = '/shop/';
        const categories = resCategories.items;
        const category_links = (productDetail.extension_attributes?.category_links || []).filter(x => x.category_id != 1);
        const categoryLink = category_links;
        breadCrumb = categories
            .filter((ct) =>
                categoryLink.some((ct2) => ct2.category_id == ct.id) && ct.level > 1
            )
            .sort((a, b) => {
                return a.level - b.level > 0 ? 1 : -1;
            })
            .map((category) => {
                const selectedCategory = category.custom_attributes.find((x) => x.attribute_code === "url_key")?.value;
                shopUrl = shopUrl + selectedCategory + "/";
                return {
                    name: category.name,
                    url: shopUrl,
                    level: category.level,
                };
            });
    }


    return {
        props: {
            key: sku,
            sku: sku,
            productId: productId,
            productDetail: productDetail,
            imagesProduct: isArray(res[1]) ? res[1] : [],
            reviewsSSR: reviews || {},
            qaSSR: qaList || {},
            breadCrumbSSR: breadCrumb || [],
        },
    };
};
